import { themes } from '../settings';
import { createTheme } from '@mui/material/styles';
import { UserTheme } from '../api/types';
import { TENANT_COLORS } from '../../../features/tenant/types';

export const createThemeConfig = (theme: UserTheme) => {
    const themeConfig = themes[theme];

    return createTheme(themeConfig);
};

export const dropdownThemePalette = Object.values(TENANT_COLORS).reduce(
    (acc: { [key: string]: { backgroundColor: string } }, color) => {
        acc[`&[data-value='${color}']:before`] = {
            backgroundColor: `common.themes.${color.toLowerCase()}.primary`,
        };
        return acc;
    },
    {}
);
